import { Component, OnInit, ViewChild } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { faInfo, faQuestionCircle, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { MatDialogRef } from '@angular/material/dialog';
import { Environment } from 'src/app/core/environment/environment';
import { SessionStorageService } from 'ngx-webstorage';
import { EntityVerificationPdfComponent } from '../entity-verification-pdf/entity-verification-pdf.component';
import { EntityService } from '../entity.service';

@Component({
    selector: 'nphs-wo-entity-verification-form',
    templateUrl: './entity-verification-form.component.html',
    styleUrls: ['./entity-verification-form.component.scss'],
    standalone: false
})

export class EntityVerificationFormComponent implements OnInit {
  showImage: boolean;   
  faQuestionCircle=faQuestionCircle;
  faInfo = faInfo;
  faTimes = faTimes;
  faInfoCircle = faInfoCircle;
  submitted:boolean = false;
  formData:any=null;
  pdfType:string ='email';

  constructor(private formBuilder: UntypedFormBuilder, 
    private cache: CacheResolverService,
    public entityVeriformDialogRef: MatDialogRef<EntityVerificationFormComponent>,
    private sessionStorage: SessionStorageService, 
    private entityService:EntityService 
  ) { }

  @ViewChild(EntityVerificationPdfComponent) pdfComponent!: EntityVerificationPdfComponent;
  
  customerShipToNum: number = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo);
  
  customerName: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).name ?
  this.cache.get(CacheConstant.LocalStorage.SelectedAccount).name : ''
pharmacyName: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).locName ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).locName : ''
locationNum: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).locationNumber ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).locationNumber : ''
customerAdress1: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerAddress1 ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerAddress1 : ''
customerCity: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerCity ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerCity : ''
customerState: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerState ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerState : ''
customerZip: string = this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerZipCode ?
this.cache.get(CacheConstant.LocalStorage.SelectedAccount).customerZipCode : ''
  
  entityVerificationForm340B: UntypedFormGroup = this.formBuilder.group(
    {
      customerShipToNum: [''],
      customerName: [''],
      prodShiptoAddress:[''],
      id: ['', Validators.required],
      hospital340BAdministratorName: ['', Validators.required],
      hospital340BAdministratorEmail: ['',[Validators.required, this.emailValidator]],
      hospitalBillNumber: ['', Validators.required],
      productBillToAddress: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      pharmacyName: [''],
      locationNum: [''],
      customerAdress1: [''],
      prodShiptoCity: [''],
      prodShiptoState: [''],
      prodShiptoZip: [''],
    }
  )
  nuctrac340BEmailInquires = Environment.getInstance().appConfig.nuctrac340BEmailInquires;

  ngOnInit(): void {
    this.initializeForm();
  }

   private initializeForm() {
    this.entityVerificationForm340B.get('customerShipToNum').setValue(this.customerShipToNum);
    this.entityVerificationForm340B.get('customerName').setValue(this.customerName);
    this.entityVerificationForm340B.get('pharmacyName').setValue(this.pharmacyName);
    this.entityVerificationForm340B.get('locationNum').setValue(this.locationNum);
    this.entityVerificationForm340B.get('prodShiptoAddress').setValue(this.customerAdress1);
    this.entityVerificationForm340B.get('prodShiptoCity').setValue(this.customerCity);
    this.entityVerificationForm340B.get('prodShiptoState').setValue(this.customerState);
    this.entityVerificationForm340B.get('prodShiptoZip').setValue(this.customerZip);    
   }

   // convenience getter for easy access to form fields
   get f() { return this.entityVerificationForm340B.controls; }

   submitForm(){
    this.submitted = true;
    if (this.entityVerificationForm340B.invalid) {
      return;
    }
    this.entityVeriformDialogRef.addPanelClass('entity-340B-overlay');    
    this.formData = this.entityVerificationForm340B.value;           
    this.submitted = false;
    this.entityService.setFormValue(this.formData); 
    this.entityVerificationForm340B.reset();      
    setTimeout(()=>{ 
      if(this.pdfComponent?.generatePdf){
        this.pdfComponent.generatePdf(this.entityVeriformDialogRef); 
      }               
    },700);        
   }

   closeForm(){
    this.submitted = false;
    this.entityVerificationForm340B.reset();
    this.entityVeriformDialogRef.close();
   }

   onMouseEnterShowToolTip(){
      this.showImage = true;
   }

   onMouseleave(){
    setTimeout(() => {this.showImage = false;}, 1000)    
   }
  
   emailValidator(control) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

}
